.datawrapper {
  background-color: var(--palette-background-primary);
}